import { useTranslation } from "react-i18next";
import { Button, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import { deleteEquipmentParts, getEquipmentPartsByQuery, postEquipmentParts } from "components/axios/equipmentAxios";
import { getEquipmentCategoriesByQuery, getEquipmentComponentLocationByCategory, getMasterEquipmentPartsByQuery } from "components/axios/equipmentCategoryAxios";
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import { useEffect } from "react";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
// import EquipmentListLayer from "components/layer/EquipmentListLayer";
import MainCard from "components/MainCard";
import AvgLifeTime from "components/AvgLifeTime";
import { getSensorsByQuery } from "components/axios/iotAxios";
// import dayjs from "utils/dayjs";
import CustomDatePicker from "components/date_picker/CustomDatePicker";
import CustomFormIotSelect from "components/select/CustomFormIotSelect";
import { deleteEquipmentSpecs, getEquipmentSpecsByEquipmentId, getLastEquipmentSpec, postEquipmentSpecs } from "components/axios/equipmentSpecAxios";
import { ROLE, safeParse } from "data/data";
import CustomSelect from "components/select/CustomSelect";
import { fromServerFormat, nowFormat, toServerFormat } from "components/date_picker/dateUtils";
import Specs from "./Specs";
import { useEnumApi } from "contexts/EnumApiContext";
// import { fromServerUTC, toServerUTC } from "components/date_picker/dateUtils";

// const EquipmentSpec = ({info, equipmentPartAllList}) => {
const EquipmentSpec = ({info}) => {
    const { loginInfo } = useEnumApi();
    const { t } = useTranslation();

    // modal 관련
    const { openModal } = useModals();
    const handleAlertClick = (alertMessage) => {
        openModal(modals.alertModal, {
            onClose : () => {
            },
            message: alertMessage,
        });
    };

    const regexDate = RegExp(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/);
    const [equipmentCategoryComponentId, setEquipmentCategoryComponentId] = useState(0);
    const [equipmentCategoryComponents, setEquipmentCategoryComponents] = useState(null);
    const [equipmentCategoryComponentsSelected, setEquipmentCategoryComponentsSelected] = useState([]);

    const [equipmentComponentLocation, setEquipmentComponentLocation] = useState('');
    const [equipmentComponentLocations, setEquipmentComponentLocations] = useState(null);
    const [equipmentComponentLocationsSelected, setEquipmentComponentLocationsSelected] = useState([]);

    const [masterEquipmentParts, setMasterEquipmentParts] = useState(null);
    const [masterEquipmentPartSelectBoxs, setMasterEquipmentPartSelectBoxs] = useState(null);

    const [equipmentPartId, setEquipmentPartId] = useState(0);
    const [equipmentParts, setEquipmentParts] = useState(null);
    // const [equipmentPartsSelected, setEquipmentPartsSelected] = useState([]);

    const [lastEquipmentSpec, setLastEquipmentSpec] = useState({}); // 마지막 스펙
    const [equipmentSpec, setEquipmentSpec] = useState(null); // 선택된 스펙
    const [equipmentSpecs, setEquipmentSpecs] = useState([]);   // 스펙목록(selectbox)

    const {control: partControl, register: partRegister, handleSubmit: partHandleSubmit, reset: partReset
        , setValue: partSetValue, formState : {isDirty: partIsDirty, errors: partErrors } } = useForm({});
    const [isLoading, setIsLoading] = useState(false);

    const { register : specRegister, handleSubmit : specHandleSubmit, reset : specReset
        , setValue: specSetValue, formState : {isDirty : specIsDirty, errors : specErrors } } = useForm({});

    // 설비구성부 목록
    const equipmentCategoryComponentList = async() => {
        const param = { "parent.id": info.equipmentCtgr.id, depth: 4, size : 100, sort : "name,asc" };
        await getEquipmentCategoriesByQuery(param).then((data) => {
            if (data && data._embedded) {
            const list = data._embedded.equipmentCategories;
            if (list) {
                setEquipmentCategoryComponents(list);
            } else {
                setEquipmentCategoryComponents(null);
            }
            } else {
            setEquipmentCategoryComponents(null);
            }
        });
    };

    // 구성부위치 목록
    const equipmentComponentLocationsList = async () => {
        await getEquipmentComponentLocationByCategory(info.equipmentCtgr.id).then((result)=>{
            // console.log(result);
            // 구성부위치
            if (result) {
                setEquipmentComponentLocations(result);
            } else {
                setEquipmentComponentLocations([]);
            }
        }).catch((err) => {
            console.log(err);
            setEquipmentComponentLocations([]);
        })
    };

    // 설비구성부 선택
    const selectEquipmentCategoryComponent = (i, data) => {
        // console.log(data)
        setEquipmentCategoryComponentId(data.id);
        // setEquipmentSpecs([]);
        // specSetUpdateValue('specLength',0);
        setEquipmentPartId(0);
        let copy = [...equipmentCategoryComponentsSelected];
        copy = Array.from({ length: copy.length }, () => null);
        copy[i] = "bold";
        setEquipmentCategoryComponentsSelected(copy);
        partSetValue("masterEquipmentPartId", '');
        partSetValue("lifeSpanTime", '');
    };

    useEffect(()=>{
        equipmentPartList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[equipmentCategoryComponentId, equipmentComponentLocation]);

    useEffect(()=>{
        masterEquipmentPartList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[equipmentCategoryComponentId]);

    // 자재 목록
    const masterEquipmentPartList = async() => {
        const param = { "equipmentCtgr.id": equipmentCategoryComponentId, size:100 };
        await getMasterEquipmentPartsByQuery(param).then((data) => {
            if (data && data._embedded) {
                const list = data._embedded.masterEquipmentParts;
                if (list) {
                    setMasterEquipmentParts(list);
                    let selectBoxList = [];
                    let selectBox ;
                    list.map((part)=>{
                        selectBox = {id:part.id, sn:part.name, name:part.code}
                        selectBoxList.push(selectBox);
                    })
                    setMasterEquipmentPartSelectBoxs(selectBoxList);
                } else {
                    setMasterEquipmentParts(null);
                    setMasterEquipmentPartSelectBoxs(null);
                }
            } else {
                setMasterEquipmentParts(null);
                setMasterEquipmentPartSelectBoxs(null);
            }
        });
    };

    // 설비구성부위치 선택
    const selectEquipmentCategoryPosition = (i, data) => {
        setEquipmentComponentLocation(data);
        let copy = [...equipmentComponentLocationsSelected];
        copy = Array.from({ length: copy.length }, () => null);
        copy[i] = "bold";
        setEquipmentComponentLocationsSelected(copy);

        setEquipmentPartId(0);
        // let copy2 = [...equipmentPartsSelected];
        // copy2 = Array.from({ length: copy2.length }, () => null);
        // setEquipmentPartsSelected(copy2);
        // setEquipmentSpecs([]);
        // specSetUpdateValue('specLength',0);
    };

    // 설비에 등록된 자재목록
    const equipmentPartList = async()=> {
        if (equipmentCategoryComponentId && equipmentComponentLocation) {
            const param = {size:50, "equipment.id": info.id, "masterEquipmentPart.equipmentCtgr.id": equipmentCategoryComponentId, "componentLocation.id": equipmentComponentLocation.id, deletedYn:false};
            await getEquipmentPartsByQuery(param).then((data) => {
                if (data && data._embedded) {
                    const list = data._embedded.equipmentParts;
                    if (list) {
                        setEquipmentParts(list);
                    } else {
                        setEquipmentParts(null);
                    }
                } else {
                    setEquipmentParts(null);
                }
            });
        }
    }

    const selectMasterEquipmentParts = (e) => {
        const selectedId = e.target.value;
        const data = masterEquipmentParts.find(item => item.id === selectedId);
        partSetValue("lifeSpanTime", (data.lifeSpanTime/24/30));
    }

    // 설비에 등록된 자재 선택
    // const selectEquipmentPart = async(i, data) => {
    //     setEquipmentPartId(data.id);
    //     // setEquipmentSpecs([]);
    //     // specSetUpdateValue('specLength',0);
    //     await getEquipmentPartsSpecOnlyById(data.id).then((resData)=>{
    //         console.log(resData);
    //         if (resData) {
    //             let specs = [];
    //             if (resData.masterEquipmentPart && resData.masterEquipmentPart.specKeys) {
    //                 resData.masterEquipmentPart.specKeys.map((msp, idx)=>{
    //                     let specValue = resData.specs.find(sp => sp.specKey.id === msp.id);
    //                     specs.push({"key":msp,"value":{"id":specValue?.specValue?.id||null, "value":specValue?.specValue?.value||null}});

    //                     // specSetUpdateValue('specKeyId'+idx, msp.id);
    //                     // specSetUpdateValue('specValueId'+idx, specValue?.specValue?.id||null);
    //                     // specSetUpdateValue('specValueUpdate'+idx, specValue?.specValue?.value||null);
    //                 })
    //             }
    //             console.log(specs)
    //             // setEquipmentSpecs(specs);
    //             // specSetUpdateValue('specLength',specs.length);
    //         } else {
    //             // setEquipmentSpecs([]);
    //             // specSetUpdateValue('specLength',0);
    //         }
    //     })
        
    //     let copy = [...equipmentPartsSelected];
    //     copy = Array.from({ length: copy.length }, () => null);
    //     copy[i] = "bold";
    //     setEquipmentPartsSelected(copy);
    // };

    useEffect(()=>{
        // console.log(info)
        // console.log(isLoading)
        if (info) {
            if (info.equipmentCtgr && !isLoading) {
                if (info.equipmentCtgr && info.equipmentCtgr.id) {
                    equipmentCategoryComponentList();
                    equipmentComponentLocationsList();
                }
            }
            if (info.id) {
                equipmentSpecList();
            }
            setIsLoading(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[info, isLoading]);

    // 자재-관리주기-설치일 추가
    const onSubmit = (data, e) => {
        // console.log(data)
        e.preventDefault();

        const masterEquipmentPartId = data.masterEquipmentPartId;
        let lifeSpanTime = data.lifeSpanTime;
        lifeSpanTime = (lifeSpanTime*30*24);

        if (data.instlAt == null || data.instlAt == '') {
            handleAlertClick(t('message.common.alert.installation.date.input'));
            return;
        }

        if (data.instlAt != null && data.instlAt != '' && !regexDate.test(data.instlAt)) {
            handleAlertClick(t('message.common.alert.installation.date.input'));
            return;
        }

        let body = {
            equipment : {
                id: info.id
            },
            masterEquipmentPart: {
                id: masterEquipmentPartId
            },
            componentLocation : {
                id: equipmentComponentLocation.id
            },
            lifeSpanTime: lifeSpanTime,
            // instlAt : toServerUTC(data.instlAt)
            instlAt : toServerFormat(data.instlAt)
            // instlAt : moment(new Date(parseInt((data.instlAt.split("-"))[0]), parseInt((data.instlAt.split("-"))[1]) - 1, parseInt((data.instlAt.split("-"))[2]), 0, 0, 0)).format()
        };

        let selectParam = {
            "equipment.id":info.id,
            "masterEquipmentPart.id":masterEquipmentPartId,
            "componentLocation.id":equipmentComponentLocation.id,
            "deletedYn":false
        };

        console.log(body)
        getEquipmentPartsByQuery(selectParam).then((res)=>{
            if (res && res._embedded && res._embedded.equipmentParts) {
                handleAlertClick(t('message.common.alert.already.registration.material'));
                return;
            } else {
                openModal(modals.confirmModal, {
                    onSubmit : (value) => {
                        postEquipmentParts(body).then((res)=>{
                            console.log(res)
                            handleAlertClick(t('message.common.alert.add'));
                            setTimeout(() => equipmentPartList(), 1000);
                            // equipmentPartAllList();
                        }).catch((err) => {
                            console.log(err);
                            handleAlertClick(err.response?.data?.message || err.message);
                        });
                        partReset();
                    },
                    onClose : () => {
                        console.log('close');
                    },
                    message: t('message.common.alert.add.question'),
                });
            }
        })
    }

    // 자재-관리주기-설치일 삭제
    const handlePartDeleteBtnClick = (param)=>{
        getSensorsByQuery({"equipmentPart.id":param}).then((data)=>{
            const isExist = data?.page?.totalElements > 0
            return isExist;
        }).then((res)=>{
            let message = '';
            if (res) {
                message = t('message.common.alert.material.delete.question');
            } else {
                message = t('message.common.alert.delete.question');
            }

            openModal(modals.confirmModal, {
                onSubmit: (value) => {
                    deleteEquipmentParts(param).then((res) => {
                        setTimeout(() => equipmentPartList(), 1000);
                        // equipmentPartAllList();
                    }).catch((err) => {
                        console.log(err);
                        handleAlertClick(err.response?.data?.message || err.message);
                    });
                    partReset();
                },
                onClose: () => {
                    console.log('close');
                },
                message: message,
            });
        })
    }

    
    // 스펙목록
    const equipmentSpecList = () => {
        getEquipmentSpecsByEquipmentId(info.id).then((res)=>{
            // console.log(res)
            if (res && res.length > 0) {
                setEquipmentSpecs(res.map((data)=> {return {...data, name:data.createdAt}}));
                getLastEquipmentSpec(info.id).then((res2)=>{
                    // console.log(res2)
                    setLastEquipmentSpec({...res2, jsonStr:JSON.stringify(JSON.parse(res2.json), null, 2)})
                    setEquipmentSpec({...res2, specs : []})
                })
            } else {
                setEquipmentSpecs([])
                setLastEquipmentSpec({})
                setEquipmentSpec(null)
            }
        }).catch((err)=>{
            setEquipmentSpecs([])
            setLastEquipmentSpec({})
            setEquipmentSpec(null)
        })
    }

    const selectEquipmentSpec = (id) => {
        if (equipmentSpecs) {
            const findSpec = equipmentSpecs.filter((es)=>es.id === id)[0];
            console.log(findSpec)
            if (findSpec)
                setEquipmentSpec({...findSpec, specs:[]});
            else
                setEquipmentSpec(null)
        }
    }

    // const [isSelected, setIsSelected] = useState(false);
    // useEffect(()=>{
    //     console.log(isSelected, equipmentSpec)
    //     if (equipmentSpec && !isSelected) {
    //         setEquipmentSpec({...equipmentSpec, specs : []})
    //         setIsSelected(true);
    //     }
    // }, [equipmentSpec, isSelected])

    // 스펙등록
    const onSubmitSpec = (data, e) => {
        e.preventDefault();
        
        let body = safeParse(data.specArea);
console.log(body)
        if (!body) {
            handleAlertClick(t('message.common.alert.json.spec.write'));
            return;
        }
        openModal(modals.confirmModal, {
            onSubmit : (value) => {
                postEquipmentSpecs(info.id, body).then((res)=>{
                    console.log(res)
                    handleAlertClick(t('message.common.alert.write.done'));
                    equipmentSpecList();
                }).catch((err)=>{
                    console.log(err);
                    handleAlertClick(err.response?.data?.message || err.message);
                });
            },
            onClose : () => {
                // console.log('close');
            },
            message: t('message.common.alert.write.question'),
        });
    };

    const deleteSpec = (id) => {
        console.log(id)
        openModal(modals.confirmModal, {
            onSubmit : (value) => {
                deleteEquipmentSpecs(info.id, id).then((res)=>{
                    handleAlertClick(t('message.common.alert.delete.done'));
                    equipmentSpecList();
                }).catch((err)=>{
                    console.log(err);
                    handleAlertClick(err.response?.data?.message || err.message);
                });
            },
            onClose : () => {
                // console.log('close');
            },
            message: t('message.common.alert.delete.question'),
        });
    }

    if (info && info.equipmentCtgr && isLoading) {
        return (
            <div style={{marginTop:"10px"}}>
                <MainCard style={{marginTop:"10px"}}>
                    <div style={{marginBottom:"10px"}}>
                        <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;
                        <Chip label={t('message.common.chip.equipment.spec')} style={{color:"#fff", backgroundColor:"#6a7075", borderRadius:"4px"}} />&nbsp;&nbsp;
                        {/* <EquipmentListLayer excludeId={info.id} equipmentCtgrId={info.equipmentCtgr.id} changeEquipment={changeEquipment} /> */}
                    </div>

                    <div>
                        <div className="scroll_table" style={{alignItems:"flex-start"}}>
                            <TableContainer sx={{width:"28%"}}>
                                <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="th" align="center">{t('message.common.select.component.part')} ({t('message.common.subtitle.category.code')})</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {equipmentCategoryComponents && equipmentCategoryComponents.map(function(item, i) {
                                    return (
                                    <TableRow key={i}>
                                        <TableCell style={{cursor:"pointer", fontWeight : equipmentCategoryComponentsSelected[i]}} onClick={()=>{
                                            selectEquipmentCategoryComponent(i, item);
                                        }}>{item.name} {(item.code && '('+item.code+')') || ''}</TableCell>
                                    </TableRow>
                                    )
                                })}
                                </TableBody>
                                </Table>
                            </TableContainer>

                            <TableContainer sx={{width:"12%"}}>
                                <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="th" align="center">{t('message.common.select.component.part')} {t('message.common.subtitle.position')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                { equipmentComponentLocations && equipmentComponentLocations.map(function(item, i) {
                                    return (
                                    <TableRow key={i}>
                                        <TableCell style={{cursor:"pointer", fontWeight : equipmentComponentLocationsSelected[i]}} onClick={()=>{
                                            selectEquipmentCategoryPosition(i, item);
                                        }}>{item.name}</TableCell>
                                    </TableRow>
                                    )
                                })}
                                </TableBody>
                                </Table>
                            </TableContainer>

                            <TableContainer sx={{width:"59%"}}>
                                <form onSubmit={partHandleSubmit(onSubmit)}>
                                <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="th" align="center">{t('message.common.subtitle.material')} ({t('message.common.subtitle.category.code')})</TableCell>
                                        <TableCell className="th" align="center">{t('message.common.subtitle.self')}{t('message.common.subtitle.management.cycle')}</TableCell>
                                        <TableCell className="th" align="center">{t('message.common.subtitle.installation.date')}</TableCell>
                                        <TableCell className="th" align="center">{t('message.common.subtitle.peer.average')}</TableCell>
                                        <TableCell className="th" align="center"></TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                { equipmentParts && equipmentParts.map(function(item, i) {
                                    return (
                                    <TableRow key={i}>
                                        <TableCell 
                                            // style={{cursor:"pointer", fontWeight : equipmentPartsSelected[i]}} 
                                            // onClick={()=>{
                                            //     selectEquipmentPart(i, equipmentParts[i]);
                                            // }}
                                        >{item.masterEquipmentPart.name} {(item.masterEquipmentPart.code && '('+item.masterEquipmentPart.code+')') || ''}</TableCell>
                                        <TableCell>{item.lifeSpanTime && (item.lifeSpanTime/24/30)}{t('message.common.text.month')}</TableCell>
                                        {/* <TableCell>{fromServerUTC(item.instlAt, {format:"YYYY-MM-DD"})}</TableCell> */}
                                        <TableCell>{item.instlAt ? fromServerFormat(item.instlAt, {format:t('message.common.text.date.format.date')}) : '-'}</TableCell>
                                        <TableCell><AvgLifeTime masterEquipmentPartId={item.masterEquipmentPart.id} componentLocationId={item.componentLocation?.id}/></TableCell>
                                        <TableCell>
                                            <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                                                handlePartDeleteBtnClick(item.id);
                                            }}>{t('message.common.btn.delete')}</Button>
                                        </TableCell>
                                    </TableRow>
                                    )
                                })}
                                </TableBody>
                                {((equipmentCategoryComponentId && equipmentComponentLocation) || '') &&
                                <tfoot>
                                    <tr>
                                        <td colSpan={2}>
                                            <Controller
                                                sx={{ m: 1, minWidth: "100%" }}
                                                aria-invalid={!partIsDirty ? undefined : partErrors.masterEquipmentPartId ? "true" : "false"}
                                                control={partControl}
                                                name="masterEquipmentPartId"
                                                render={({ field: {name} }) => (
                                                <CustomFormIotSelect
                                                    style={{ minWidth: '90%' }}
                                                    label={t('message.common.subtitle.material')}
                                                    register={partRegister}
                                                    name={name}
                                                    requiredMessage={t('message.common.alert.material.select')}
                                                    defaultValue={''}
                                                    list={masterEquipmentPartSelectBoxs}
                                                    onChange={selectMasterEquipmentParts}
                                                />
                                                )}
                                            />
                                            {partErrors.masterEquipmentPartId && <small role="alert"><br></br>{partErrors.masterEquipmentPartId.message}</small>}
                                        </td>
                                        <td>
                                            <TextField id="outlined-basic" 
                                                aria-invalid={!partIsDirty ? undefined : partErrors.lifeSpanTime ? "true" : "false"}
                                                defaultValue={''}
                                                {...partRegister("lifeSpanTime", {
                                                    required : t('message.common.error.text.self.management.cycle.input')
                                                })} 
                                                sx={{ minWidth: '100%', backgroundColor: "#fff" }} />
                                            {partErrors.lifeSpanTime && <small role="alert"><br></br>{partErrors.lifeSpanTime.message}</small>}
                                        </td>
                                        <td>
                                            <Controller
                                                sx={{ m: 1, minWidth: "100%" }}
                                                aria-invalid={!partIsDirty ? undefined : partErrors.instlAt ? "true" : "false"}
                                                control={partControl}
                                                name="instlAt"
                                                // defaultValue={''}
                                                rules={{ required: t('message.common.alert.installation.date.input') }}
                                                render={({ field: { name, value, ...field }, ref, fieldState }) => (
                                                    <CustomDatePicker 
                                                        sx={{minWidth:"115px"}}
                                                        // defaultValue={dayjs(new Date()).format('YYYY-MM-DD')}
                                                        field={field} ref={ref} name={name} value={nowFormat(t('message.common.text.date.format.date'))} register={partRegister} 
                                                        // requiredMessage={t('message.common.alert.installation.date.input')}
                                                        setValue={partSetValue} fieldState={fieldState}
                                                        // viewDeleteBtn={false}
                                                    />
                                                )}
                                            />
                                        </td>
                                        <td>
                                            <Button variant="contained" color="primary" className="small_btn" onClick={partHandleSubmit(onSubmit)}>{t('message.common.btn.add')}</Button>
                                        </td>
                                    </tr>
                                </tfoot>
                                }
                                </Table>
                                </form>
                            </TableContainer>
                        </div>

                        <br/>
                        {equipmentSpecs && equipmentSpecs.length > 0 &&
                        <TableContainer sx={{width:"100%", border:"2px solid gray", marginBottom:"10px", paddingTop:"11px" }}>
                            <CustomSelect
                                // key={'selectSpec'}
                                label={t('message.common.alert.spec.select')}
                                labelName={t('message.common.alert.spec.select')}
                                name={'selectSpec'}
                                value={equipmentSpec?.id || ''}
                                onChange={(e)=>{
                                //    console.log(e.target.value)
                                if (e.target.value) {
                                        selectEquipmentSpec(e.target.value)
                                } else {
                                    handleAlertClick(t('message.common.alert.spec.select'))
                                }
                                }}
                                list={equipmentSpecs}
                            />
                            {t('message.common.text.spec.infoHint')}
                            {(equipmentCategoryComponentId !== 0 && equipmentComponentLocation?.id !== '' && equipmentSpec?.id) && <Specs equipmentId={info.id} specId={equipmentSpec?.id} componentId={equipmentCategoryComponentId} componentLocation={equipmentComponentLocation.id} />}
                        </TableContainer>
                        }
                        {(loginInfo && loginInfo.role == ROLE.SA.code) &&
                        <div style={{display:"flex","marginRight":"2px"}}>
                            <TableContainer sx={{width:"100%", border:"2px solid gray", textAlign:"center"}}>
                                <TextField 
                                    id="outlined-basic" 
                                    aria-invalid={!specIsDirty ? undefined : specErrors.specArea ? "true" : "false"}
                                    {...specRegister('specArea', {
                                        required : t('message.common.error.text.spec.json.input')
                                    })} 
                                    multiline
                                    rows={10}
                                    defaultValue={lastEquipmentSpec?.jsonStr || ''}
                                    sx={{ width: '99%' }}
                                />
                                {specErrors.specArea && <small role="alert"><br></br>{specErrors.specArea.message}</small>}
                                <div className="btn_right" style={{margin:"8px", alignItems:"center" }}>
                                    {/* <Button variant="contained" color="primary" onClick={()=>{console.log(2)}}>{t('message.common.btn.write')}</Button> */}
                                    {t('message.common.text.spec.jsonInputGuide')}
                                    <Button variant="contained" color="primary" onClick={specHandleSubmit(onSubmitSpec)}>{t('message.common.btn.write')}</Button>
                                </div>
                            </TableContainer>
                        </div>
                        }
                    </div>
                </MainCard>
            </div>
        )
    }
}
export default EquipmentSpec;